module.exports = __webpack_public_path__ + "img/OnDemand.acbbf79b.svg";